module.exports = __webpack_public_path__ + "img/DNADamage-CRC_CRLM.9c244524.png";